import { SelectField } from "@/components/SelectField";

/** One thing on file that a step can copy in: a person, an address. */
export interface RecordChoice {
  key: string;
  label: string;
}

/**
 * A dropdown of what is already on file that a WC wizard step can copy in
 * (Nav, 2026-10-09: the account's people, like its addresses, are picked from
 * a list). Choosing one adds it at once and the dropdown goes back to its
 * prompt, ready for the next. Nothing shows once there is nothing to add.
 */
export function AddFromRecord({
  label,
  placeholder,
  choices,
  onAdd,
  disabled,
}: {
  label: string;
  placeholder: string;
  choices: readonly RecordChoice[];
  onAdd: (key: string) => void;
  disabled?: boolean;
}) {
  if (choices.length === 0) return null;
  return (
    <div className="sm:max-w-md">
      <SelectField
        label={label}
        placeholder={placeholder}
        options={choices.map((c) => ({ value: c.key, label: c.label }))}
        value=""
        onChange={(e) => {
          if (e.target.value) onAdd(e.target.value);
        }}
        disabled={disabled}
        optional
      />
    </div>
  );
}
